import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidDate } from '@common/utils';

export function dateRangeValidatorFactory(dateFromKey: string, dateToKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (!group.value) return null;

    const dateFromCtrl = group.get(dateFromKey);
    const dateToCtrl = group.get(dateToKey);
    const resetTime = (value: string) => new Date(value).setHours(0, 0, 0, 0);

    const dateFrom = dateFromCtrl?.value;
    const dateTo = dateToCtrl?.value;

    if (!dateFrom && !dateTo) return null;

    if (dateFrom && !isValidDate(dateFrom)) {
      dateFromCtrl?.setErrors({ ...(dateFromCtrl.errors || {}), invalidDate: true });

      return null;
    }

    if (dateTo && !isValidDate(dateTo)) {
      dateToCtrl?.setErrors({ ...(dateToCtrl.errors || {}), invalidDate: true });

      return null;
    }

    if (dateFrom && dateTo) {
      return resetTime(dateFrom) <= resetTime(dateTo) ? null : { greaterOrEqualToDate: true };
    }

    return null;
  };
}
